import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

export default createReactClass({

	propTypes: {
		data: PropTypes.object
	},

	renderField(key, comp) {
		const value = this.props.data[key];
		if (value !== '') {
			return comp(value);
		}
	},

	render() {
		return (
			<li className="slx-contact slx-contact--usa">
				<div className="slx-contact__wrap">
					<div className="slx-contact__header">
						<h3 className="slx-contact__field slx-contact__field--title">
							<strong>{this.renderField('company', value => <span>{value}</span>)}</strong>
						</h3>
					</div>
					<div className="slx-contact__content">
						<div className="slx-contact__field slx-contact__field--adress">
							{this.renderField('street_1', value => <span className="slx-contact__line">{value}</span>)}
							{this.renderField('street_2', value => <span className="slx-contact__line">{value}</span>)}
							{this.renderField('city', value => value)}, {this.renderField('statecode', value => `${value} `)} {this.renderField('zipcode', value => `${value} `)}
						</div>
						{this.renderField('tel', value => (
							<div className="slx-contact__field slx-contact__field--tel">
								T <span className="bold">{value}</span>
							</div>))}
						{this.renderField('mob', value => (
							<div className="slx-contact__field slx-contact__field--tel">
								M <span className="bold">{value}</span>
							</div>))}
						{this.renderField('fax', value => (
							<div className="slx-contact__field slx-contact__field--tel">
								F <span className="bold">{value}</span>
							</div>))}
						{this.renderField('email', value => (
							<div className="slx-contact__field slx-contact__field--email">
								<a className="bold" href={`mailto:${value}`}>{value}</a>
							</div>))}
					</div>
				</div>
			</li>
		);
	}
});
